import { environment } from '../../../environments/environment';
import { HttpClient, } from '@angular/common/http';
import { SystemService } from '../../service/system.service';
var iccService = (function () {
    function iccService(http) {
        this.http = http;
        this.dataModelUrl = '';
        var systemService = new SystemService();
        if (environment && environment.properties) {
            this.dataModelUrl = systemService.getDataModelUrl();
        }
    }
    iccService.prototype.getInboundCallCenterData = function (depId) {
        var url = this.dataModelUrl + "cci_dashboard?sort={\"_id\":-1}&pagesize=1&filter={\"department.id\":" + depId + "}";
        return this.http.get(url)
            .toPromise()
            .then(function (response) {
            return response;
        })
            .catch(function (reason) {
            console.error(reason);
            // return reason;
        });
    };
    return iccService;
}());
export { iccService };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/services/icc/icc.service.ts.pre-build-optimizer.js